export default "__VITE_ASSET__BvCZyrLF__"